// Dependencies
import React, {useEffect, useState} from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

// Components
// import DataProvider from '../Contexts/DataProvider';
import { useAuth } from '../Contexts/AuthContext';
// import Constants from '../constants';
import Account from '../Pages/Account/account';
import Dashboard from '../Pages/Dashboard/dashboard';
import LandingPage from '../Pages/LandingPage/landingPage';
import Login from '../Pages/Login/login';
import NewProject from '../Pages/NewProject/newProject';
import ProjectHome from '../Pages/ProjectHome/projectHome';
import ProjectSelect from '../Pages/ProjectSelect';
import ResetPassword from '../Pages/ResetPassword/resetPassword';
import SetPassword from '../Pages/SetPassword/setPassword';
import ForgotPassword from '../Pages/ForgotPassword/forgotPassword';
import ExportList from '../Pages/ExportList/exportList';
import AdminKnowledgebase from '../Pages/AdminKnowledgebase/adminKnowledgebase';

function ProtectedRoute({children, ...rest}){
  const auth = useAuth();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.activeUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        )
      }
    />
  );
}

export default function AppRouter({ children }) {
  const auth = useAuth();
  // console.log("auth", auth);
  // useEffect(() => {
  //   if(auth.activeUser){

  //   }
  // }, [auth.activeUser])
  // console.log(auth.activeUser);
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route
          path="/login"
          render={({ location }) => 
            auth.activeUser ? (
              auth.activeUser.firstTimeSignIn ? (
                <Redirect
                  to={{
                    pathname: '/reset-password?first-time-sign-in',
                  }}
                />
              ) : (
                <Redirect
                to={{
                  pathname: '/project-home',
                }}
              />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route exact path="/set-password" component={SetPassword} />
        <Route exact path="/forgot-password" component={ForgotPassword} />

        
        <ProtectedRoute path="/dashboard">
          <Dashboard />
        </ProtectedRoute>
        <ProtectedRoute path="/new-project">
          <NewProject />
        </ProtectedRoute>
        <ProtectedRoute path="/project-select">
          <ProjectSelect />
        </ProtectedRoute>
        <ProtectedRoute path="/project-home">
          <ProjectHome />
        </ProtectedRoute>
        <ProtectedRoute path="/account">
          <Account />
        </ProtectedRoute>
        <ProtectedRoute path="/export">
          <ExportList />
        </ProtectedRoute>
        <ProtectedRoute path="/admin/knowledgebase">
          <AdminKnowledgebase />
        </ProtectedRoute>
      </Switch>
    </Router>
  );
}
